<template>
    <v-row class="" justify="start" justify-md="end">
        <v-col cols="auto" class="store-tabs-wrap">
            <v-row justify="start" class="position-relative">
                <v-col class="px-0 py-0 pb-1 store-tabs-label">Filtrar por:</v-col>
            </v-row>
            <v-tabs
                v-model="tab"
                class="store-tabs"
                height="52"
                slider-size="0"
                slider-color="transparent"
                background-color="cyan"
                next-icon="mdi-chevron-right"
                prev-icon="mdi-chevron-left"
                show-arrows
                @change="$emit('new-tab', tab)"
            >   
                <v-tab
                    data-cy="filter-tab-store"
                    v-for="(item, index) in items"
                    :key="index"
                    class="no-uppercase text-subtitle-1 tab-items"
                    active-class="active-tab-item"
                >
                    <v-img
                        :src="tab === index ? item.iconActive : item.iconDefault"
                        height="40"
                        width="40"
                        class="mr-2">
                    </v-img>
                    <v-img
                        v-if="index == 0"
                        :src="require('@/assets/img/icons/store/new-tag.png')"
                        height="38"
                        width="65"
                        class="new-section-tag">
                    </v-img>
                    {{ item.label }}
                </v-tab>
            </v-tabs>
        </v-col>
    </v-row>
</template>

<script>

import { mapState } from 'vuex'

export default {
    data() {
        return {
            tab: null,
            search: ''
        }
    },
    computed: {
        ...mapState({
            coins: (state) => state.userData.coins
        }),
        items () {
            const itemsWithIcons = [
                { label: this.$t('store.magazines'),
                  iconDefault: require('@/assets/img/icons/store/book.png'),
                  iconActive: require('@/assets/img/icons/store/book-stroke.png'),
                },
                { label: this.$t('store.avatars'),
                  iconDefault: require('@/assets/img/icons/store/avatar.png'),
                  iconActive: require('@/assets/img/icons/store/avatar-stroke.png'),
                },
                { label: this.$t('store.skins'),
                  iconDefault: require('@/assets/img/icons/store/skin.png'),
                  iconActive: require('@/assets/img/icons/store/skin-stroke.png'),
                },
            ];
            return itemsWithIcons;
        }
    },
    watch: {
        search() {
            this.$emit('search', this.search)
        }
    }
}
</script>

<style lang="scss" scoped>
.no-uppercase {
     text-transform: none;
}
.v-tabs-bar {
    height: 80px  !important;
}
.v-tabs-bar__content {
    height: 80px  !important;
}
.v-tabs-slider-wrapper {
    height: 5px;
}

.v-chip:before {
    background-color: white;
}
.store-tabs-wrap{
    @media screen and (min-width: 600px) {
        background: white;
        border-radius: 16px;
        padding: 16px 24px;
    }
    .store-tabs-label{
        display: none;
        @media screen and (min-width: 600px) {
            display: inline-flex;
            font-weight: 600;
            left: 22px;
            position: relative;
        }
    }
}
.store-tabs{
    .tab-items {
        background-color: #EEECF8;
        border-radius: 6px;
        margin-left: 8px;
        margin-right: 8px;
        padding: 0 12px;
        &:not(.active-tab-item){
            color: #514585!important;
        }
        @media screen and (max-width: 600px) {
            margin-left: 4px;
            margin-right: 4px;
        }
    }
    .active-tab-item{
        background: linear-gradient(147.2deg, #A295DA 4.28%, #7764CA 33.93%, #6857B2 62.04%, #514585 95.25%);
        color: white;
        font-weight: 600;
    }
}
// ::v-deep .v-slide-group__prev.v-slide-group__prev--disabled{
//     display: none!important;
// }
// ::v-deep .v-tabs:not(.v-tabs--vertical):not(.v-tabs--right)>.v-slide-group--is-overflowing.v-tabs-bar--is-mobile:not(.v-slide-group--has-affixes) .v-slide-group__prev{
//     display: none!important;
// }
::v-deep .v-tabs-bar{
    background-color: transparent!important;
}
::v-deep .v-slide-group__content{
    margin-top: 12px;
}
.new-section-tag{
    position: absolute;
    right: 0;
    top: -1em;
}
</style>